module.exports = __webpack_public_path__ + "static/media/img111.91e84447.jpg";